import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/advantage',
    name: 'Advantage',
    component: () => import('../views/Advantage.vue')
  },
  {
    path: '/productIntroRas',
    name: 'ProductIntroRas',
    component: () => import('../views/ProductIntroRas.vue')
  },
  {
    path: '/productIntroChengTu',
    name: 'ProductIntroChengTu',
    component: () => import('../views/ProductIntroChengTu.vue')
  },
  {
    path: '/productIntroXiaofangshu',
    name: 'ProductIntroXiaofangshu',
    component: () => import('../views/ProductIntroXiaofangshu.vue')
  },
  {
    path: '/productIntroOpenPlatform',
    name: 'ProductIntroOpenPlatform',
    component: () => import('../views/ProductIntroOpenPlatform.vue')
  },
  {
    path: '/productIntroRes',
    name: 'ProductIntroRes',
    component: () => import('../views/ProductIntroRes.vue')
  },
  {
    path: '/businessCooperation',
    name: 'BusinessCooperation',
    component: () => import('../views/BusinessCooperation.vue')
  },
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue')
  },
  {
    path: '/privacyAgreement', 
    name: 'PrivacyAgreement',
    component: () => import('../views/PrivacyAgreement.vue')
  },
  {
    path: '/disclaimers', 
    name: 'Disclaimers',
    component: () => import('../views/Disclaimers.vue')
  },
  {
    path:"/devSupport",
    name: 'DevSupport',
    component: () => import('../views/DevSupport.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 控制不同跳转相同页面
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
